// When image is successfully uploaded we save the nodeId and upload response.
// Used in setEditor: if a user edits while the image is in placeholder state, undo can
// return to placeholder — image nodes check saved upload responses by nodeId.

export default function imageUploads(state = {}, action) {
  switch (action.type) {
    case 'MEDIA_UPLOAD_SUCCESS':
      return {
        ...state,
        [action.nodeId]: action.mediaUploadResponse,
      }

    case 'LOGOUT':
      return {}

    default:
      return state
  }
}
